export const initialFormValues = {
  customerName: '',
  technician: '',
  date: '',
  workOrderNumber: '',
  offeredMaintenancePlan: '',

  // Electrical
  electricalManufacturer: '',
  electricalOverallVisualCondition: '',
  electricalWholeHouseSurgeProtectionNA: false,
  electricalWholeHouseSurgeProtection: '',
  electricalWiringSecuredProperlyTerminated: '',
  electricalWholeHomeGeneratorNA: false,
  electricalWholeHomeGeneratorCondition: '',
  electricalProperClearance: '',
  electricalNotes: '',

  // Water Treatment
  waterTreatmentNA: false,
  waterTreatmentManufacturer: '',
  waterTreatmentType: '',
  waterTreatmentVisibleCondition: '',
  waterTreatmentRecommendedAnnualMaintenance: '',
  waterTreatmentFiltersOrSaltRequired: '',
  waterTreatmentWaterQualityComplaints: '',
  waterTreatmentLocationForSolution: '',
  waterTreatmentNotes: '',

  // Indoor Air Quality
  airQualityAirFilterCondition: '',
  airQualityIwave: '',
  airQualityHumidifier: '',
  airQualityDehumidifier: '',
  airQualityProgrammableThermostat: '',
  airQualityNotes: '',
};

export type InspectionFormValues = typeof initialFormValues;
